module.exports = __webpack_public_path__ + "static/media/map.d65aa0dc.svg";